import { IMPORT_STATS_JOB_STATUS } from 'cargo-chief-commons';
import { INPUT_TYPES } from '@shared/tabbed-table/constants';

export const IMPORT_STATS_FIELDS = {
	CREATED: 'Created',
	JOB_STATUS: 'Job Status',
	USER: 'User',
	FILE_NAME: 'File Name',
	TOTAL_ROWS: 'Total Rows',
	ROWS_PARSED: 'Rows Parsed',
	ROWS_INSERTED: 'Rows Inserted',
	ROWS_FAILED: 'Rows Failed',
	INVALID_ROWS: 'Invalid Rows',
	TYPE: 'Type',
};

export function buildHeaders() {
	return [
		{ dataName: 'select', formattedName: 'select' },
		{ dataName: 'created', formattedName: IMPORT_STATS_FIELDS.CREATED },
		{ dataName: 'jobStatus', formattedName: IMPORT_STATS_FIELDS.JOB_STATUS },
		{ dataName: 'userName', formattedName: IMPORT_STATS_FIELDS.USER },
		{ dataName: 'filename', formattedName: IMPORT_STATS_FIELDS.FILE_NAME },
		{ dataName: 'totalRows', formattedName: IMPORT_STATS_FIELDS.TOTAL_ROWS },
		{ dataName: 'rowsParsed', formattedName: IMPORT_STATS_FIELDS.ROWS_PARSED },
		{ dataName: 'rowsInserted', formattedName: IMPORT_STATS_FIELDS.ROWS_INSERTED },
		{ dataName: 'rowsFailed', formattedName: IMPORT_STATS_FIELDS.ROWS_FAILED },
		{ dataName: 'invalidRows', formattedName: IMPORT_STATS_FIELDS.INVALID_ROWS },
	];
}

export const HEADERS_DATATYPES = [
	'date',
	'string',
	'string',
	'string',
	'number',
	'number',
	'number',
	'number',
	'number',
];

export const DISPLAYED_COLUMNS = [
	'select',
	'created',
	'jobStatus',
	'userName',
	'filename',
	'totalRows',
	'rowsParsed',
	'rowsInserted',
	'invalidRows',
];

export const SORT_FIELDS = [
	IMPORT_STATS_FIELDS.CREATED,
	IMPORT_STATS_FIELDS.JOB_STATUS,
	IMPORT_STATS_FIELDS.USER,
	IMPORT_STATS_FIELDS.FILE_NAME,
	IMPORT_STATS_FIELDS.TOTAL_ROWS,
	IMPORT_STATS_FIELDS.ROWS_PARSED,
	IMPORT_STATS_FIELDS.ROWS_INSERTED,
	IMPORT_STATS_FIELDS.ROWS_FAILED,
	IMPORT_STATS_FIELDS.INVALID_ROWS,
];

export const SORT_FIELD_MAPS = {
	[IMPORT_STATS_FIELDS.CREATED]: 'created',
	[IMPORT_STATS_FIELDS.JOB_STATUS]: 'job_status',
	[IMPORT_STATS_FIELDS.USER]: 'c4_user_id',
	[IMPORT_STATS_FIELDS.FILE_NAME]: 'filename',
	[IMPORT_STATS_FIELDS.TOTAL_ROWS]: 'total_rows',
	[IMPORT_STATS_FIELDS.ROWS_PARSED]: 'rows_parsed',
	[IMPORT_STATS_FIELDS.ROWS_INSERTED]: 'rows_inserted',
	[IMPORT_STATS_FIELDS.ROWS_FAILED]: 'rows_failed',
	[IMPORT_STATS_FIELDS.INVALID_ROWS]: 'invalid_rows',
};

export const FILTER_FIELDS = [
	IMPORT_STATS_FIELDS.CREATED,
	IMPORT_STATS_FIELDS.JOB_STATUS,
	IMPORT_STATS_FIELDS.USER,
	IMPORT_STATS_FIELDS.FILE_NAME,
	IMPORT_STATS_FIELDS.TOTAL_ROWS,
	IMPORT_STATS_FIELDS.ROWS_PARSED,
	IMPORT_STATS_FIELDS.ROWS_INSERTED,
	IMPORT_STATS_FIELDS.ROWS_FAILED,
	IMPORT_STATS_FIELDS.INVALID_ROWS,
];

export const IMPORT_STATS_JOBS_STATUS = [
	{
		label: 'Queued',
		type: IMPORT_STATS_JOB_STATUS.QUEUED,
	},
	{
		label: 'Completed',
		type: IMPORT_STATS_JOB_STATUS.COMPLETED,
	},
	{
		label: 'In Progress',
		type: IMPORT_STATS_JOB_STATUS.IN_PROGRESS,
	},
	{
		label: 'Failed',
		type: IMPORT_STATS_JOB_STATUS.FAILED,
	},
	{
		label: 'Legacy',
		type: IMPORT_STATS_JOB_STATUS.LEGACY,
	},
];

export let filterFieldsInputTypeMap: Map<string, string> = new Map<string, string>();
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.CREATED, INPUT_TYPES.DATE);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.JOB_STATUS, INPUT_TYPES.IMPORT_STATS_JOB_STATUS);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.USER, INPUT_TYPES.USERS_LIST);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.FILE_NAME, INPUT_TYPES.STRING);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.TOTAL_ROWS, INPUT_TYPES.NUMBER);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.ROWS_PARSED, INPUT_TYPES.NUMBER);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.ROWS_INSERTED, INPUT_TYPES.NUMBER);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.ROWS_FAILED, INPUT_TYPES.NUMBER);
filterFieldsInputTypeMap.set(IMPORT_STATS_FIELDS.INVALID_ROWS, INPUT_TYPES.NUMBER);
